<template>
    <div class="form-wrapper">

        <form @submit.prevent="submit" accept-charset="UTF-8" method="post">
            <div class="signup-fieldset">
              <b-form-input v-model="name" placeholder="Your name" required="required" type="text" class="signup-account-input" autofocus="autofocus" name="name"></b-form-input>
              <b-form-input v-model="username" placeholder="Your work email" required="required" type="email" class="signup-account-input" autofocus="autofocus" name="email" pattern="[^@]+@[^@]+\.[a-zA-Z]*"></b-form-input>
              <b-form-input v-model="password" placeholder="Password" required="required" type="password" class="signup-account-input" autofocus="autofocus" name="password"></b-form-input>

              <!-- Not yet handled
              <b-form-checkbox size="xs" class="subscribe-checkbox" v-model="subscribe">Sign me up for news, discounts and more</b-form-checkbox>
              -->

              <div class="error" v-if="loginError">{{loginErrorText}}</div>
              <b-button type="submit" name="commit" class="signup-account-submit" :disabled="loginBusy || (!formValid && !formEmpty)">
                <span v-if="loginBusy">Signing Up...</span>
                <span v-else><slot>Sign Up for Free <i class="fa fa-arrow-right"></i></slot></span>
              </b-button>
            </div>
        </form>
  </div>

</template>

<style scoped>
@import '~scss/colors.scss';

.subscribe-checkbox {
  color: #aaa;
  text-align: left;
  font-size: 11px;
  text-transform: uppercase;
  padding-left: 20px;
  padding-top: 5px;
  margin-right: 0;
  width: 100%;
}
 .form-wrapper {
    display: block;
    width:100%;
    margin: 0 auto 1em auto;
  }


.signup-fieldset {
    display: block;
    min-width: 250px;
    max-width: 500px;
    /* padding-top: 3em; */
  }



  .signup-account-input,
  .signup-account-submit  {
    width: 100%;
    font-weight: 400;
    border-radius: 0;
    padding: 10px 20px;
    margin: 10px auto;
  }

  .signup-account-submit {
    background-color:$red;
    border: $red 1px solid;
    color: $white;
    text-shadow: 1px 1px 1px rgba(0,0,0,0.3);
  }

</style>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      name: "",
      username: "",
      password: ""
    };
  },
  computed: {
    ...mapGetters(["loginBusy", "loginError", "loginErrorText"]),
    formValid() {
      return (
        this.name &&
        this.username &&
        this.password
      );
    },
    formEmpty() {
      return !(this.name || this.username || this.password);
    }
  },
  methods: {
    ...mapActions(["signUp"]),
    async submit() {
      console.log('submit');
      let { name, username, password } = this;
      await this.signUp({ username, password, confirm_password: password, name });
      if (!this.loginError) this.$router.push("/welcome");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/SignUpForm.vue